'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapFontStyles = exports.ToolboxSection = exports.EditorComponentWrapper = undefined;

var _EditorComponentWrapper2 = require('./EditorComponentWrapper');

var _EditorComponentWrapper3 = _interopRequireDefault(_EditorComponentWrapper2);

var _ToolboxSection2 = require('./ToolboxSection');

var _ToolboxSection3 = _interopRequireDefault(_ToolboxSection2);

var _mapFontStyles2 = require('./mapFontStyles');

var _mapFontStyles3 = _interopRequireDefault(_mapFontStyles2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EditorComponentWrapper = _EditorComponentWrapper3.default;
exports.ToolboxSection = _ToolboxSection3.default;
exports.mapFontStyles = _mapFontStyles3.default;
exports.default = {};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/common/index.js
// module id = 36
// module chunks = 0